'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.hoursAgo;


// WEBPACK FOOTER //
// ./~/sugar-date/number/hoursAgo.js